/**
 * Create the user's isOnboarded flag and set it to false.
 */
const createIsOnboarded = (user) => {
  user.isOnboarded = false;
}

export default createIsOnboarded;
